// MF async boundary — standalone 기동 시 공유 스코프 초기화를 보장.
import('./bootstrap');
